import { getUserFreeTrialDays } from 'utils/userAuth'

import { PaywallMessages, PaywallType } from '../types'

export const paywallMessages: Record<PaywallType, PaywallMessages> = {
  csv: {
    title: {
      freeTrialEligible: 'export_csv_trial_heading',

      notEligible: 'export_csv_upgrade_heading',
      variables: [getUserFreeTrialDays()],
    },
    description: {
      freeTrialEligible: 'export_csv_trial_subheading',
      notEligible: 'export_csv_upgrade_subheading',
    },
    button: {
      freeTrialEligible: 'start_trial_button',
      notEligible: 'upgrade',
    },
  },
  keyword_ideas: {
    title: {
      freeTrialEligible: 'access_kw_ideas_trial',
      notEligible: 'access_kw_ideas_upgrade',
      variables: [getUserFreeTrialDays()],
    },
    description: {
      freeTrialEligible: 'access_kw_ideas_number',
      notEligible: 'access_kw_ideas_number',
    },
    button: {
      freeTrialEligible: 'start_trial_button',
      notEligible: 'upgrade',
    },
  },
  backlinks: {
    title: {
      freeTrialEligible: 'access_backlinks_trial',
      notEligible: 'access_backlinks_upgrade',
      variables: [getUserFreeTrialDays()],
    },
    description: {
      freeTrialEligible: 'access_backlinks_number',
      notEligible: 'access_backlinks_number',
    },
    button: {
      freeTrialEligible: 'start_trial_button',
      notEligible: 'upgrade',
    },
  },
}
